const polyfill = [];

if (typeof window !== 'undefined' && !window.URLSearchParams) {
  polyfill.push(
    import(
      /* webpackChunkName: "polyfill-url-search-params" */ 'url-search-params-polyfill'
    )
  );
}

export default polyfill;
